import { z } from 'zod';
import { SavedViewSnapshotSchema, SavedViewSurfaceKeySchema, SurfacePrefsSchema } from './requests.js';
// Response schemas for saved views (ADR-057). Field-exposure rule (ANATOMY §L7):
// the row carries exactly what the tab strip consumes — identity, name, the
// opaque snapshot, order, default flag. Timestamps stay off the wire (no
// consumer). List order = `position` (persisted; reorder UI deferred).
export const SavedViewSchema = z
    .object({
    id: z.string().max(16),
    surface_key: SavedViewSurfaceKeySchema,
    name: z.string().max(60),
    snapshot: SavedViewSnapshotSchema,
    position: z.number().int(),
    is_default: z.boolean(),
})
    .strict();
// ── GET list — pagination "none": the caller's OWN rows per surface (≤ dozens
// by construction; the widest trust zone sees the same self-scoped set). ──────
export const SavedViewsListResponseSchema = z
    .object({ items: z.array(SavedViewSchema) })
    .strict();
// ── the surface-default store ─────────────────────────────────────────────────
export const SurfacePrefEntrySchema = z
    .object({ surface_key: SavedViewSurfaceKeySchema, prefs: SurfacePrefsSchema })
    .strict();
// GET /api/auth/me/surface-prefs — ALL of the caller's rows (one per surface a
// person ever touched — dozens at most; one read at boot serves every page).
export const SurfacePrefsResponseSchema = z.object({ items: z.array(SurfacePrefEntrySchema) }).strict();
